import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useAppContext } from 'new-components/OpAppScaffold/AppContext';
import { getControlCenterOrigin } from 'utils/getControlCenterOrigin';

export const useNavigateToAccess = (orgId: number | null) => {
  const { app } = useAppContext();
  const navigate = useNavigate();

  const handleNavigateToAccess = useCallback(() => {
    if (app === 'access') {
      navigate(0);
      return;
    }
    let accessUrl = getControlCenterOrigin();
    if (orgId) {
      accessUrl += `/o/${orgId}/`;
    }
    if (accessUrl) {
      window.open(accessUrl, '_blank');
    }
  }, [app, navigate, orgId]);

  return {
    handleNavigateToAccess,
  };
};
